import { EntityType } from '@frontend/common';
import { productCategoryRequest } from '@frontend/group/events';
import { IGroup } from '@frontend/group/types';
import { CommonMessage, getCorrectTranslation, useLocale } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import {
    PRODUCT_CATEGORY_LINKED_LABEL,
    ProductCategoryDetailsCard,
    ProductCategoryGeneralSection,
    ProductCategoryLinkedSection
} from './product-category-detail-sections';

const ProductCategoryTitle = ({ category }: { category: IGroup }) => {
    const { locale } = useLocale();
    return (
        <div className='flex gap-1'>
            <span>{CommonMessage.OBJECTS.CATEGORY.DEFAULT}:</span>
            <span>{locale ? getCorrectTranslation(locale, category, 'name') : category.name}</span>
        </div>
    );
};

export const productCategoryReactiveDetail: ReactiveDetailRegistryEntry<IGroup> = {
    entityType: EntityType.PRODUCT_CATEGORY,
    resolveFunction: productCategoryRequest,
    modalClassName: 'w-full xl:w-1/2 max-w-[900px]',
    title: ({ object }) => <ProductCategoryTitle category={object} />,
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: ({ object }) => (
                <>
                    <ProductCategoryDetailsCard category={object} />
                    <ProductCategoryGeneralSection category={object} />
                </>
            )
        },
        {
            id: 'linked_products',
            label: PRODUCT_CATEGORY_LINKED_LABEL,
            render: ({ object }) => <ProductCategoryLinkedSection category={object} />
        }
    ]
};
